/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
    APIResponseErrorToJSONTyped,
} from './APIResponseError';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
    APIMetaToJSONTyped,
} from './APIMeta';

/**
 * 
 * @export
 * @interface PostDirectId201Response
 */
export interface PostDirectId201Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof PostDirectId201Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof PostDirectId201Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {string}
     * @memberof PostDirectId201Response
     */
    result?: string;
}

/**
 * Check if a given object implements the PostDirectId201Response interface.
 */
export function instanceOfPostDirectId201Response(value: object): value is PostDirectId201Response {
    return true;
}

export function PostDirectId201ResponseFromJSON(json: any): PostDirectId201Response {
    return PostDirectId201ResponseFromJSONTyped(json, false);
}

export function PostDirectId201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostDirectId201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'meta': json['meta'] == null ? undefined : APIMetaFromJSON(json['meta']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': json['result'] == null ? undefined : json['result'],
    };
}

export function PostDirectId201ResponseToJSON(json: any): PostDirectId201Response {
    return PostDirectId201ResponseToJSONTyped(json, false);
}

export function PostDirectId201ResponseToJSONTyped(value?: PostDirectId201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'meta': APIMetaToJSON(value['meta']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(APIResponseErrorToJSON)),
        'result': value['result'],
    };
}

